export const VALIDATION = {
  anneeSemaineRequired: 'Vous devez sélectionner une semaine pour chaque produit réseau',
  qteFacesSouhaiteesInf: 'Le nombre de faces souhaitées doit être supérieur à 0.',
  notProposableLc: 'La face {ref} n\'est pas proposable en vente LC',
  sansSuiteForbiddenWithOrder: 'Impossible de classer ce devis sans suite car un ou des acomptes sont rattachés à ce devis',
  faceDateOverlap: 'Impossible de vendre la même face dans la même commande avec des dates se chevauchant',
  leastOneCustomer: 'Vous devez sélectionner au moins un client par devis.',
  fusionEcheancierVenteInterne: 'Si vous vendez un produit d\'une autre société, vous ne pouvez pas avoir un échéancier regroupé',
  needDiscount: 'Vous devez renseigner la remise',
  normalLine: 'Une ligne de devis est nécessaire entre 2 lignes de remises',
  leastOneAdvertiser: 'Vous devez indiquer au moins un annonceur par devis',
  leastOnePayer: 'Vous devez indiquer au minimum un payeur par devis.',
  pourcentageDivision: 'La somme des pourcentages de facturation doit être égale à 100%.',
  amountDivision: 'La somme des quotes-parts de facturation doit être égale au montant total du devis.',
  proxyNotRepresentative: 'Un client ne peut être annonceur et mandataire sur un même devis.',
  unitPriseLessZero: 'Le prix unitaire des produits doit être supérieur à 0.',
  quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
  sameProduct: 'Impossible d\'ajouter le même produit à la même date',
  discountBetween0100: 'La remise de la ligne en pourcentage doit être entre 0 et 100',
  discountBetween0Amount: 'La remise de la ligne en montant doit être entre 0 et le montant de celle-ci',
  leastOneProduct: 'Vous devez saisir au minimum un produit dans le devis.',
  notSameDivisionType: 'Les quotes-parts des payeurs doivent être du même type',
  saveImpossible: 'Enregistrement du devis impossible.',
  editImpossible: 'Modification du devis impossible.',
  quotationNotfound: 'Le devis n\'a pas été trouvé.',
  notSaveState: 'L\'état du devis doit être "enregistré".',
  agenceId: 'Vous devez sélectionner une agence.',
  notQuotation: 'La commande ne peut être créée qu\'à partir d\'un devis.',
  notOrder: 'Aucune commande n\'a été générée.',
  sumMontantAcompteGreat: 'La somme des montants des acomptes dépasse le montant total du devis.',
  acompteMultipayeurForbidden: 'Le multipayeur est impossible avec des devis ayant des acomptes.',
  ShoudContainsLocationOrBillBoard: 'La vente doit contenir au moins une ligne',
  TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de la vente',
  etatObtenu: 'Au moins une ligne de vente contient un état obtenu à "{etatObtenu}"',
  faceNotAvailable: 'Une des faces sélectionnées dans un réseau n\'est pas disponible',
  faceNotAvailableInSelection: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine}',
  sameFaceInSameWeek: 'La face {face} ne peut pas être sélectionnée à la même semaine ({semaine}) de l\'année {annee} sur différents réseaux temporaires',
  faceSelectGreaterThanFaceWish: 'Le nombre de faces sélectionnées est plus grand que le nombre de faces souhaitées',
  lineMustBeBloque: 'Pour sélectionner des faces, l\'état d\'option et blocage de la ligne doit être à "bloqué"',
  devisCommandeNotCancel: 'Le devis ou la command ne doit pas être annulé',
  newCommandeLigneAtEnd: 'Les nouvelles lignes de vente ajouté à un devis partiellement commandé doivent être à la fin du devis',
  onlyOnePayeur: 'Impossible d\'avoir plusieurs payeur si le role est différent de \'Régie\'',
  noRegroupementPerso: 'Impossible d\'avoir un regroupement personalisé si le le role est différent de \'Régie\'',
  echeancierManuelShouldHaveEcheancierLignes: 'Un échéancier manuel doit avoir des lignes d\'échéanciers',
  googleMapKeyInvalid: 'La clef API google est invalide',
  etatDemandeShouldBeTrue: 'L\'état de la demande doit être correctement envoyé',
  sameBillingType: 'Les lignes de commande de l\'échéancier doivent avoir le même type de facturation',
  noMoreOneHundred: 'Le total des commissions ne doit pas faire plus que 100%',
  parutionNeeded: 'La parution est obligatoire pour le produit: {produit}',
  sameSupplier: 'Les lignes de commande de l\'échéancier doivent avoir le même fournisseur',
  cantOrderWithProspec: 'Impossible de commander un devis avec un intervenant prospec',
  lockedClient: 'L\'intervenant {nomCommercial} est Totalement bloqué',
  name: {
    role: 'Rôle',
    libelleLigneCommande: 'Libellé de la ligne',
    quantiteLigneCommande: 'Quantité de la ligne',
    prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
    remiseLigneCommande: 'Remise de la ligne',
    tauxTvaLigneCommande: 'Taux de Tva de la ligne',
    dateDevisCommande: 'La date de devis',
    dateValidite: 'Date de validité',
    repartitionIntervenant: 'Quote-part facturation',
    tauxPenalite: 'Taux de pénalité',
    tauxEscompte: 'Taux d\'escompte',
    remise: 'Remise',
    numStand: 'N° stand',
  },
  payerWithSameExonerationTva: 'Tous les payeurs doivent être éxonérés de TVA',
  ligneCommandeWithZeroTva: 'Si un payeur est exonéré de TVA, les lignes de ventes doivent avoir un taux de TVA à 0',
  partial: {
    alreadyOrdered: 'Une ligne de commande est déjà commandée',
    insideBundle: 'Une ligne de commande est dans un regroupement',
    insideCustomBundle: 'Une ligne de commande est dans un réseau personnalisé',
    notQuotation: 'Une ligne de commande n\'existe pas dans le devis',
    lineWrongType: 'Les lignes de commande doivent être de type regroupement, personnalisé ou normal. Mais une ligne était de type "{typeLigne}"',
    etatSuiviId: 'L\'état de suivi dans les lignes de suivi administratif',
  },
  productPurchase: 'Le produit {libelle} doit avoir un produit opposé de sens achat',
  ligneCommandeWithoutLigneLocation: 'La vente du réseau {reseau} doit avoir une ligne location',
  saveOrDraftRequire: 'Le devis {code} doit être à l\'état enregistré ou brouillon',
  notExist: 'Le devis {code} n\'existe plus',
  ligneCmdSelOptionProduitHasPartialSelection: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}',
  ligneCmdSelOptionProduitHasTfs: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}',
  ligneCmdSelOptionProduitOneNotExist: 'L\'une des faces sélectionnés sur la ligne {ligne} n\'existe pas ou est inactif',
  ligneCmdSelOptionProduitSelectedOnce: 'La face {face}, sélectionné pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}, ne peut être sélectionnée qu\'une seule fois',
  ligneCmdSelOptionProduitIsInactive: 'La face {face}, sélectionné pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}, est actuellement inactive',
  ligneCmdSelOptionProduitsInDevis: 'La sélection de face en demande d\'option ne peut être faite que sur des lignes de devis',
  ligneCmdSelOptionProduitsInDevisVente: 'La sélection de face en demande d\'option ne peut être faite que sur une vente',
  ligneCmdSelOptionProduitsInVenteTempos: 'La sélection de face en demande d\'option ne peut être faite que sur une vente temporaire',
  messageIndispo: {
    commande: 'la commande',
    devis: 'le devis',
    parCommercial: 'par {commercial}',
    faceDansVenteTempos: 'La face est indisponible car elle est vendue sur {dcfType} {dcfCode} avec le réseau {reseau} {commercial} à {annonceur}',
    faceArchive: 'La face est indisponible car elle est archivée',
    faceVenteLC: 'La face est indisponible car elle est vendue du {dateDebut} au {dateFin} sur {dcfType} {dcfCode} {commercial} à {annonceur}',
    faceAffecteLogistiquement: 'La face a été affecté logistiquement. {reseauDcfLibelle}',
    faceIndisponible: 'La face est marquée indisponible dans le catalogue',
    faceSelectionAucuneVente: 'Un problème est survenu contacter le support',
  },
};

export const NOTHING = '';



// WEBPACK FOOTER //
// ./src/i18n/fr/devisCommande/devis.js